import { render, staticRenderFns } from "./xeUsageSetting.vue?vue&type=template&id=1952738c&scoped=true"
import script from "./xeUsageSetting.vue?vue&type=script&lang=js"
export * from "./xeUsageSetting.vue?vue&type=script&lang=js"
import style0 from "./xeUsageSetting.vue?vue&type=style&index=0&id=1952738c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952738c",
  null
  
)

export default component.exports